import { CardSuit } from "../card/Card";
import { TrumpSuit } from "../state/TableStateMachine";

export function CardSuitToTrumpSuit(cardSuit: CardSuit):TrumpSuit
{
    switch(cardSuit) {
        case CardSuit.CLUBS: 
            return TrumpSuit.CLUBS;
        case CardSuit.DIAMONDS:
            return TrumpSuit.DIAMONDS;
        case CardSuit.HEARTS:
            return TrumpSuit.HEARTS;
        case CardSuit.SPADES:
            return TrumpSuit.SPADES;
    }
}